import React from 'react';

interface IconProps {
  size?: number;
  className?: string;
}

export const DermatologyIcon: React.FC<IconProps> = ({ size = 16, className = '' }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M8 3V13M3 8H13"
        stroke="#5B9BD5"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <circle cx="8" cy="8" r="6" stroke="#5B9BD5" strokeWidth="1.5" fill="none" />
    </svg>
  );
};
